var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tai-xiu-board-layout",
      class: { "tai-xiu-board-layout--with-top": _vm.hasTop },
    },
    [
      _vm.hasTop
        ? _c(
            "div",
            { staticClass: "tai-xiu-board-layout__top" },
            [_vm._t("top")],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "tai-xiu-board-layout__main" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }